<template>
  <div v-if="$store.getters.isAdmin === true" class="content">
    <sui-message error v-if="$store.state.admin.error !== ''">{{$store.state.admin.error}}</sui-message>
    <sui-menu tabular menu secondary tabbed>
      <!--        <sui-menu-item header>Device Details</sui-menu-item>-->
      <sui-menu-menu position="left">
        <a
          is="sui-menu-item"
          v-for="item in navItems"
          :key="item"
          :active="isActive(item)"
          :content="item"
          @click="select(item)"
        ></a>
      </sui-menu-menu>
    </sui-menu>

    <!-- pages -->
    <div class="sub-content">
      <device-management v-if="active === 'List Devices'" />
      <device-management-register v-if="active === 'Register Devices'" />
      <customer-management v-if="active === 'Customer Management'" />
      <locaite-status v-if="active === 'Locaite Status'" />
      <registrations v-if="active === 'Pending Registrations'" />
      <activation-code-management v-if="active === 'Activation Codes'" />
      <cache v-if="active === 'Cache'" />
      <api-test v-if="active === 'API Test'" />
    </div>

  </div>
  <div v-else>
    Not an admin user
  </div>

</template>
<script>
  import DeviceManagement from "../components/admin/DeviceManagement";
  import LocaiteStatus from "../components/admin/LocaiteStatus";
  import DeviceManagementRegister from "../components/admin/DeviceManagementRegister";
  import CustomerManagement from "../components/admin/CustomerManagement";
  import Registrations from "../components/admin/Registrations";
  import ActivationCodeManagement from "../components/admin/ActivationCodeManagement";
  import Cache from "../components/admin/Cache";
  import ApiTest from "@/components/admin/apitest/ApiTest";
  export default {
    components: {
      ApiTest,
      Cache,
      ActivationCodeManagement,
      Registrations, CustomerManagement, DeviceManagementRegister, LocaiteStatus, DeviceManagement},
    data() {
      return {
        active: 'List Devices',
        // navItems: ['List Devices', 'Register Devices', 'User Management', 'Locaite Status']
        navItems: ['List Devices', 'Register Devices', 'Locaite Status', 'Customer Management', 'Pending Registrations', 'Activation Codes', 'Cache', 'API Test']
      };
    },
    methods: {
      isActive(name) {
        return this.active === name;
      },
      select(name) {
        this.active = name;
      },
    }
  }
</script>

<style scoped>
  .content {
    padding: 10pt;
  }
  .sub-content {
    padding: 5pt;
  }

</style>
